import { ICalendarEvent } from "@/interfaces/dashboard.interface";

/**
 * Mock calendar events data
 */
export const mockCalendarEvents: ICalendarEvent[] = [
  {
    id: "event-1",
    title: "Gravação de cena externa - Explosão do Carro Vermelho",
    description: "Gravação da cena de ação principal com efeitos especiais. Equipe completa necessária no estúdio principal em São Paulo.",
    date: "2025-08-29",
    startTime: "12:00",
    endDate: "2025-08-29",
    endTime: "18:00",
  },
  {
    id: "event-2",
    title: "Entrega das telas de Layout",
    description: "Deadline para entrega das telas de layout finalizadas do projeto. Trabalho remoto com apresentação online.",
    date: "2025-08-22",
    startTime: "09:00",
    endDate: "2025-08-22",
    endTime: "17:00",
  },
  {
    id: "event-3",
    title: "Emissão da Nota Fiscal de Agosto",
    description: "Processamento e emissão de todas as notas fiscais referentes aos serviços prestados no mês de agosto.",
    date: "2025-08-26",
    startTime: "10:00",
    endDate: "2025-08-26",
    endTime: "12:00",
  },
  {
    id: "event-4",
    title: "Pagamento da fatura de Agosto",
    description: "Processamento de pagamentos de fornecedores e prestadores de serviço referentes ao mês de agosto.",
    date: "2025-08-29",
    startTime: "14:00",
    endDate: "2025-08-29",
    endTime: "16:00",
  },
  {
    id: "event-5",
    title: "Reunião de Pré-Produção",
    description: "Reunião de alinhamento da equipe de pré-produção para definição de cronograma e alocação de recursos na Sala de Reuniões 2.",
    date: "2025-08-05",
    startTime: "14:00",
    endDate: "2025-08-05",
    endTime: "16:00",
  },
  {
    id: "event-6",
    title: "Aprovação de Orçamento",
    description: "Reunião para aprovação final do orçamento do projeto com todos os stakeholders e investidores.",
    date: "2025-08-12",
    startTime: "11:00",
    endDate: "2025-08-12",
    endTime: "13:00",
  },
  {
    id: "event-7",
    title: "Ensaio Geral - Elenco Principal",
    description: "Ensaio geral com todo o elenco principal no Teatro Municipal. Preparação final antes das gravações.",
    date: "2025-08-15",
    startTime: "09:00",
    endDate: "2025-08-15",
    endTime: "17:00",
  },
  {
    id: "event-8",
    title: "Fechamento de Contratos - Equipe Técnica",
    description: "Finalização e assinatura dos contratos com toda a equipe técnica do projeto.",
    date: "2025-08-08",
    startTime: "10:00",
    endDate: "2025-08-08",
    endTime: "12:00",
  },
  {
    id: "event-9",
    title: "Deadline - Entrega de Roteiro Revisado",
    description: "Prazo final para entrega da versão revisada do roteiro incorporando todas as sugestões da equipe criativa.",
    date: "2025-08-20",
    startTime: "18:00",
    endDate: "2025-08-20",
    endTime: "18:00",
  },
  {
    id: "event-10",
    title: "Teste de Câmera e Iluminação",
    description: "Testes técnicos de câmera e iluminação na locação em Barbacena para preparação das cenas externas.",
    date: "2025-08-27",
    startTime: "08:00",
    endDate: "2025-08-27",
    endTime: "12:00",
  },
];
